<template>
    <section :class="[{ open }, 'checkout-basket p-lg-4']">
        <span class="hidden-from-lg">
            <button @click="open = !open" class="checkout-basket-toggle w-100 d-flex justify-content-between">
                <span class="d-flex">
                    <shopping-bag-icon class="mr-1" />
                    {{ $t('basket.show_cart') }}
                    <chevron-down-icon />
                </span>
                <span class="text-dark">{{ summary.total | currency }}</span>
            </button>
        </span>

        <div
            v-if="items.length"
            :class="[{ 'sr-only': !open }, 'checkout-basket-content mt-2 mt-lg-0']"
        >
            <div class="d-flex flex-row-reverse align-items-center justify-content-between mb-2">
                <a href="/winkelwagen">{{ $t('basket.edit') }}</a>
                <h3>{{ $t('basket.cart') }}</h3>
            </div>

            <checkout-summary-item
                v-for="item in items"
                :key="item.id"
                :item="item"
            />

            <div class="basket-summary">
                <div class="basket-summary-top">
                    <div class="basket-summary-item d-flex justify-content-between">
                        <div>{{ $t('basket.subtotal') }}</div>
                        <div class="price">
                            <span
                                v-if="isBusinessUser"
                            >
                                {{ summary.subtotal.exc | currency }}
                            </span>
                            <span
                                v-else
                            >
                                {{ summary.subtotal.inc | currency }}
                            </span>
                        </div>
                    </div>

                    <div v-if="isBusinessUser">
                        <div
                            v-for="(vat, index) in summary.vats"
                            class="basket-summary-item d-flex justify-content-between"
                        >
                            <div>{{ $t('basket.vat') }} {{ index }} %</div>
                            <div class="price">{{ vat | currency }}</div>
                        </div>
                    </div>

                </div>
                <div class="basket-summary-bottom">
                    <div class="basket-summary-item d-flex justify-content-between">
                        <div>
                            {{ $t('basket.shipping_costs') }}
                            <p
                                v-if="summary.shipping_threshold_left !== 0"
                                class="basket-summary-free-shipping mt-1"
                            >
                                {{ $t('basket.free_shipping', {
                                    'threshold': formatCurrency(summary.shipping_threshold),
                                    'threshold_left': formatCurrency(summary.shipping_threshold_left),
                                }) }}
                            </p>
                        </div>
                        <div class="price">
                            <span
                                v-if="isBusinessUser"
                            >
                                {{ summary.shipping_costs.exc | currency }}
                            </span>
                            <span
                                v-else
                            >
                                {{ summary.shipping_costs.inc | currency }}
                            </span>
                        </div>
                    </div>
                    <div v-if="summary.discount.voucher > 0" class="basket-summary-item d-flex justify-content-between">
                        <div>{{ $t('basket.discount_code') }} ({{summary.voucher_code }})</div>
                        <div class="price"> - {{ summary.discount.voucher | currency }}</div>
                    </div>

                    <div v-if="summary.discount.customer > 0" class="basket-summary-item d-flex justify-content-between">
                        <div>{{ $t('basket.customer_discount')}}</div>
                        <div class="price"> - {{ summary.discount.customer | currency }}</div>
                    </div>

                    <div
                        v-if="summary.gift_wrap"
                        class="basket-summary-item d-flex justify-content-between"
                    >
                        <div>{{ $t('basket.gift_wrap') }}</div>
                        <div class="price text-nowrap">{{ summary.gift_wrap_costs | currency }}</div>
                    </div>

                    <div v-if="isBusinessUser">
                        <div
                            class="basket-summary-item d-flex justify-content-between"
                        >
                            <div>{{ $t('basket.vat') }} {{ summary.shipping_vat }} %</div>
                            <div class="price">{{ summary.shipping_vat_amount | currency }}</div>
                        </div>
                    </div>

                    <div class="basket-summary-item basket-summary-total d-flex justify-content-between mt-1">
                        <div>{{ $t('basket.total') }}</div>
                        <div class="price text-nowrap">{{ summary.total | currency }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="isLoading" class="basket-updating">
            <p class="text-center mb-1">{{ $t('basket.updating') }}</p>
            <spinner />
        </div>
    </section>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { ChevronDownIcon, ShoppingBagIcon } from 'vue-feather-icons';
    import CheckoutSummaryItem from '@/_vue/components/checkout/summary-item';
    import Spinner from '@/_vue/components/ui/spinner';

    export default {
        name: 'CheckoutSummary',
        components: {
            CheckoutSummaryItem,
            ChevronDownIcon,
            ShoppingBagIcon,
            Spinner,
        },
        props: {
            basketUrl: {
                required: true,
            },
        },
        data() {
            return {
                open: false,
            };
        },
        created() {
            this.setBasketDefaults({
                basketRoute: this.basketUrl,
            });

            this.fetchBasket();
        },
        computed: {
            ...mapState('basket', {
                items: 'items',
                isLoading: 'isLoading',
                summary: 'summary',
            }),
        },
        methods: {
            ...mapActions('basket', [
                'fetchBasket',
            ]),

            ...mapMutations('basket', [
                'setBasketDefaults',
            ]),
        },
    };
</script>
